<button
  type="button"
  mat-stroked-button
  color="primary"
  class="delete-btn"
  [disabled]="(isAllGivenMerchantsSelected$ | async) === 'NOT_CHECKED'"
  (click)="deleteSelectedItems()"
>
  {{ "VIP_DISCOUNTS.GIVEN.DELETE_SELECTED_ITEMS" | translate }}
</button>
<app-vip-discounts-given-table
  *ngFor="let discount of discountsGiven$ | async; let i = index"
  [discount]="discount"
  [tableIndex]="i"
  [showCaptionRow]="i === 0"
></app-vip-discounts-given-table>
